// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ServiceIntervalStatuses = t.struct({
    allowed: t.Array,
    selected: t.Array
}, 'ServiceIntervalStatuses');

export const getDefaultState = () =>
    new ServiceIntervalStatuses({
        allowed: [],
        selected: []
    });

export default ServiceIntervalStatuses;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/state/service-interval-statuses.js